import React from 'react';
import { DialogActions } from '@mui/material';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import useInvoiceDetailsDialog from '../../hooks/dialogs/useInvoiceDetailsDialog';
import InvoiceDetails from '../invoiceDetails/InvoiceDetails';
import { useTranslation } from 'react-i18next';
import InvoiceProducts from '../invoiceDetails/InvoiceProducts';
import useInvoiceProductsSWR from '../../hooks/invoices/useInvoiceProducts';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';
import ButtonOutlined from '../shared/Buttons/ButtonOutlined';
import useHandleBulkProductsToCart from '../../hooks/cart/useHandleBulkProductsToCart';
import { AddToCartProp } from '../../models/Cart';
import { InvoiceDetailsData } from '../../models/Invoice';

const InvoiceDetailsWrapper = () => {
    const invoiceDetailsDialog = useInvoiceDetailsDialog();
    const { t } = useTranslation('invoices', {
        keyPrefix: 'INVOICE_DETAILS',
    });
    const invoiceDetailsRow = invoiceDetailsDialog.dialogContent;
    const handleBulkProductsToCart = useHandleBulkProductsToCart();

    const { products, isLoading, isError, productNumber } =
        useInvoiceProductsSWR(invoiceDetailsRow.id);

    const convertProductsToCart = (
        products: InvoiceDetailsData[]
    ): AddToCartProp[] => {
        return products.map((elem) => {
            return {
                shopify_variant_id: elem.shopify_variant_id,
                quantity: elem.quantity,
                lineType: elem.lineType,
            };
        });
    };

    const handleGoToCart = (): void => {
        invoiceDetailsDialog.closeDialog();
    };

    const addToCart = () => {
        handleBulkProductsToCart.handleAddToCart(
            convertProductsToCart(products),
            'INVOICE_DETAILS.PRODUCTS_ADDED_DIALOG',
            'invoices',
            handleGoToCart
        );
    };

    return (
        <>
            <StyledDialogContent>
                <InvoiceDetails invoice={invoiceDetailsRow} />
                <InvoiceProducts
                    products={products}
                    isLoading={isLoading}
                    isError={isError}
                />
            </StyledDialogContent>
            <DialogActions>
                {!isLoading && (
                    <PrimaryBtn onClick={addToCart}>
                        {t('ADD_TO_CART')} ({productNumber})
                    </PrimaryBtn>
                )}
                <ButtonOutlined onClick={invoiceDetailsDialog.closeDialog}>
                    {t('CLOSE')}
                </ButtonOutlined>
            </DialogActions>
        </>
    );
};

export default InvoiceDetailsWrapper;
